export default __webpack_public_path__ + "static/intro-pc-694110c30a9fb00316247b68c58cf540.png";